import request from "../utils/request.js"
// 获取订单列表
export function getOrderListApi(params) {
    return request({
        url: "/order/list",
        method: "post",
        data: params,
    })
}
// 获取订单服务详情及合同附件
export function getOrderDetailApi(params) {
    return request({
        url: "/order/detail/" + params,
        method: "get"
    })
}
// 获取订单产品类型列表
export function getOrderType() {
    return request({
        url: "/order/getOrderType",
        method: "get"
    })
}
// 保存订单信息
export function saveOrderApi(params) {
    return request({
        url: "/order/saveOrder",
        method: "post",
        data: params,
    })
}